export default {
    firebaseObjectToTreeview(fbObj) {
        return this.addChildren(fbObj.root);
    },
    addChildren(childObj) {
        let childArray = [];
        for (var key in childObj) {
            let item = {
                id: key,
                name: childObj[key].name,
                type: childObj[key].type,
                path: childObj[key].path,
                level: childObj[key].level,
                createdBy: childObj[key].createdBy,
                createdDate: childObj[key].createdDate,
            }
            if ("children" in childObj[key] && childObj[key].type==="folder") {
                item.children = this.addChildren(childObj[key].children);
            }
            if ("files" in childObj[key] && childObj[key].type==="folder") {
                item.files = this.addFiles(childObj[key].files)
            }
            if ("image" in childObj[key] && childObj[key].type==="folder") {
                item.image = childObj[key].image;
            }
            if ("description" in childObj[key] && childObj[key].type==="folder") {
                item.description = childObj[key].description;
            }
            childArray.push(item);
        }
        return childArray;
    },
    addFiles(filesObj) {
        let filesArray = [];
        for (var key in filesObj) {
            let item = {
                id: key,
                name: filesObj[key].name,
                ext: filesObj[key].ext,
                type: filesObj[key].type,
                path: filesObj[key].path,
                level: filesObj[key].level,
                storagePath: filesObj[key].storagePath,
                createdBy: filesObj[key].createdBy,
                modifiedBy: filesObj[key].modifiedBy,
                createdDate: filesObj[key].createdDate,
                modifiedDate: filesObj[key].modifiedDate,
                description: filesObj[key].description,
                version: filesObj[key].version,
                displayName: filesObj[key].displayName,
                size: filesObj[key].size
            }
            filesArray.push(item);
        }
        return filesArray;
    },
    getFolderProperties(foldStruct, folderId) {
        let folderProperties = null;
        for(var i=0; i<foldStruct.length;i++) {
            if(foldStruct[i].id === folderId && foldStruct[i].type === "folder") {
                folderProperties = {
                    id: foldStruct[i].id,
                    name: foldStruct[i].name,
                    type: foldStruct[i].type,
                    path: foldStruct[i].path,
                    level: foldStruct[i].level,
                    createdBy: foldStruct[i].createdBy,
                    createdDate: foldStruct[i].createdDate,
                }
                if("children" in foldStruct[i]) {
                    folderProperties.hasChildren = true;
                    folderProperties.children = foldStruct[i].children;
                } else {
                    folderProperties.hasChildren = false;
                }
                if("files" in foldStruct[i]) {
                    folderProperties.hasFiles = true;
                    folderProperties.files = foldStruct[i].files;
                } else {
                    folderProperties.hasFiles = false;
                    folderProperties.files = [];
                }
                if("image" in foldStruct[i]) {
                    folderProperties.image = foldStruct[i].image;
                }
                if("description" in foldStruct[i]) {
                    folderProperties.description = foldStruct[i].description;
                }
                break;
            }
            else if ("children" in foldStruct[i]) {
                folderProperties = this.getFolderProperties(foldStruct[i].children, folderId);
            }
            if (folderProperties !== null) {
                return folderProperties;
            }
        }
        return folderProperties;
    },
    calculateFolderBreadCrumbs (foldStruct, folderName, folderPath) {
        let breadCrumbs = [];
        const parentFolderIds = folderPath.split("fileContainer/root/")[1].split("/children/");
        parentFolderIds.forEach((item) => {
            if (item === "") {
                breadCrumbs.push(folderName);
            } else {
                const foldProps = this.getFolderProperties(foldStruct, item);
                breadCrumbs.push(foldProps.name);
            }
        });
        return breadCrumbs;
    },
    ifFolderNameRepeated (foldStruct, folderName, parentId) {
        const parentProps = this.getFolderProperties(foldStruct, parentId);
        if ("children" in parentProps) {
            for(var i=0; i<parentProps.children.length; i++) {
                if (parentProps.children[i].name === folderName) {
                    return true;
                }
            }
        } else {
            return false;
        }
        return false;
    },
    ifFileNameRepeated (foldStruct, fileName, parentId) {
        const parentProps = this.getFolderProperties(foldStruct, parentId);
        const name = fileName.substr(0, fileName.lastIndexOf('.'));
        const ext = fileName.substr(fileName.lastIndexOf('.')+1).toLowerCase();
        const sanitizedFileName = name + "." + ext;
        if("files" in parentProps){
            for(var i=0; i<parentProps.files.length; i++) {
                if(parentProps.files[i].name
                    + "."
                    + parentProps.files[i].ext 
                    === sanitizedFileName) {
                    return true;
                }
            }
        } else {
            return false;
        }
        return false;
    }
}